export const getDatasetsOpacityCollection = (datasets) => datasets
    .reduce((acc, dataset) => (Object.assign(Object.assign({}, acc), { [dataset.id]: dataset.opacity !== undefined ? dataset.opacity : 100 })), {});
